import { jwtDecode, JwtPayload } from 'jwt-decode';

interface TokenDetails {
  tokenExpireTime: number;
  tokenTimeRemainingUntilExpiration: number;
  willExpireSoon: boolean;
}

export const ExtractTokenDetails = (token: string): TokenDetails => {
  const decodedToken = jwtDecode<JwtPayload>(token);

  const currentTime: number = Math.floor(Date.now() / 1000);
  const tenMinutesInSeconds: number = 10 * 60;
  if (!decodedToken.exp) {
    throw new Error('Token does not have an expiration time');
  }
  const tokenExpireTime: number = decodedToken.exp;
  const tokenTimeRemainingUntilExpiration: number = tokenExpireTime - currentTime;
  const willExpireSoon: boolean = tokenTimeRemainingUntilExpiration < tenMinutesInSeconds;

  return {
    tokenExpireTime,
    tokenTimeRemainingUntilExpiration,
    willExpireSoon,
  };
};
